// import trae from 'axios'
import axios from 'axios'

const irgeApiServices = axios.create({
  baseURL: process.env.API_IRGE
})

export default irgeApiServices



// WEBPACK FOOTER //
// ./src/services/irgeLocal.js